<div class="group-tile"
  (click)="onGroupClick()"
  [title]="('Redirect to group'|translate) +': ' +group.name"
  (mouseenter)="hovering=true;"
  (mouseleave)="hovering=false;"
  [ngClass]="{'tile-loading' : loadingMenuItem, 'loading': !haloFolderClass}">
  <div class="group-info">
    <span class="group-info-icon traffic-light" [ngClass]="haloFolderClass || 'text-primary'"
      [ngbPopover]="popOverContent" [disablePopover]="!machineStatusEventDetails.length"
      #popover="ngbPopover" triggers="mouseenter:mouseleave" placement="bottom-left"
      [title]="(machineStatusEventDetails.length ? ('Redirect to status page' | translate) : ('Redirect to group' | translate)) + ': ' + group.name"
      (click)="onFolderClick($event)">
      <i class="fa-solid fa-folder" [ngClass]="{'fa-folder-open' : hovering,'fa-folder': !hovering}"></i>
    </span>
    <ng-template #popOverContent>
      @if (machineStatusEventDetails.length) {
        <div>
          @for (item of machineStatusEventDetails; track item) {
            <div>
              <i class="fa-solid fa-fw mr-1" [ngClass]="item.className"></i>
              <span [innerText]="item.machineCount"></span>
              <span translate> machine(s)</span>
            </div>
          }
        </div>
      }
    </ng-template>
    <div class="group-info-title">
      <strong class="title">
        @if (group.disabled) {
          <span class="fa-solid fa-eye-slash text-muted mr-2"
            placement="top"
            [ngbTooltip]="'Content may not be visible to your user.' | translate"
          ></span>
        }
        <span [innerText]="group.name"></span>
      </strong>
      <span class="data">
        <span class="data-item ng-binding">
          <span class="mr-1">
            @if (group.disabled) {
              <span> - </span>
            }
            @if (!group.disabled) {
              <span>
                @if (group.machinesCount < 0) {
                  <span class="fa-solid fa-spinner fa-spin"></span>
                } @else {
                  <span [innerText]="group.machinesCount + ' '"></span>
                }
              </span>
            }
          </span>
          <span translate>Machines</span>
        </span>
        <span class="data-item ng-binding">
          <span class="mr-1">
            @if (group.groupsCount < 0) {
              <span class="fa-solid fa-spinner fa-spin"></span>
            } @else {
              <span [innerText]="group.groupsCount + ' '"></span>
            }
          </span>
          <span translate>Groups</span>
        </span>
      </span>
    </div>
  </div>
</div>
